import type { MinigameModule } from "./MinigameHost";

export const MINIGAME_REGISTRY: Record<string, () => Promise<{ default: MinigameModule }>> = {
  lockpick:     () => import("../minigames/lockpick/index"),
  memorymatch:  () => import("../minigames/memorymatch/index"),
  sleuth:       () => import("../minigames/sleuth/index"),
  unscramble:   () => import("../minigames/unscramble/index"),
  sokoban:      () => import("../minigames/sokoban/index"),
  wireconnect:  () => import("../minigames/wireconnect/index"),
  passages:     () => import("../minigames/passages/index"),
  flow:         () => import("../minigames/flow/index"),
  // ── Card game family (all use the same module; ID scopes the Blackboard namespace) ──
  tri_peaks:    () => import("../minigames/cardgame/index"),  // _mg_tri_peaks_*
  blackjack:    () => import("../minigames/cardgame/index"),  // _mg_blackjack_*
  scat:         () => import("../minigames/cardgame/index"),  // _mg_scat_*
  goofspiel:    () => import("../minigames/cardgame/index"),  // _mg_goofspiel_*
};
